import type { ReactNode } from "react";
import styles from "./WorkerStatusBadge.module.css";

export type WorkerStatusBadgeProps = {
  // 서버가 판정한 online 여부(is_online). 목록 셀과 상세 헤더가 같은 값을 그린다.
  online: boolean;
};

// online/offline 배지. online은 채운 점, offline은 빈 점이다. 색과 형태로 함께 구분한다.
// 점은 장치 헬스 신호다. 그래서 c6 status.device 램프가 칠한다(CSS). 글자는 text 램프가 칠한다.
// 두 축을 한 요소에 겹치면 status 를 글자색으로 쓰게 된다(`src/styles.test.ts`).
export function WorkerStatusBadge({ online }: WorkerStatusBadgeProps): ReactNode {
  const toneClass = online ? styles.live : styles.offline;
  return (
    <span className={`${styles.badge} ${toneClass}`}>
      <span className={styles.dot} aria-hidden="true" />
      {online ? "Live" : "오프라인"}
    </span>
  );
}
